import {Component} from '@angular/core';

@Component({
	selector: 'notfound',
	template: 'Not found! - 404 error!'
})
export class NotFoundComponent {
	constructor() {
		
	}
}
